// ============================================================================
// Tiny reactive store for UI state (session, profile, stats). Presentation-only
// — the portable core holds no UI state. Subscribe/notify pattern, no deps.
// ============================================================================

const state = {
  session: null,
  profile: null,
  stats: null,
  isAdmin: false,
  pendingUserCount: 0,
  route: '#/',
};

const listeners = new Set();

export function getState() {
  return state;
}

export function setState(patch) {
  Object.assign(state, patch);
  listeners.forEach((fn) => fn(state));
}

export function subscribe(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
